import { useCleanPostData } from '../contexts/CleanPostDataContext'
import { theme, styled } from 'twin.macro'
import Chip, { ChipVariant } from '@components/DesignSystem/Chip'
import PopLink from '@components/PopLink'
import { tagUrl } from '@libs/appUrl'
import { trackArticleTagEnterWebTagEvent } from '@libs/eventTracking/article/article.tag.enter-web-tag'

function Tag(props) {
  const { tag } = props
  const { post } = useCleanPostData()
  const url = tagUrl(tag)

  const trackEnterEvent = () => {
    trackArticleTagEnterWebTagEvent({
      article: post,
      toPageUrl: url,
      tag,
    })
  }

  return (
    <PopLink url={url} shouldOpenInCurrentTab onClick={trackEnterEvent}>
      <StyledChip variant={ChipVariant.primary} as="span">
        {tag}
      </StyledChip>
    </PopLink>
  )
}

function ArticleTags() {
  const { tags } = useCleanPostData()

  if (tags.length === 0) return null

  return (
    <Container>
      {tags.slice(0, 10).map((tag, index) => {
        return <Tag key={index} tag={tag} />
      })}
    </Container>
  )
}

const Container = styled.div`
  margin-top: 8px;
`

const StyledChip = styled(Chip)`
  display: inline-block;
  margin-right: 8px;
  margin-bottom: 12px;
  @media (min-width: ${theme`screens.md`}) {
    margin-bottom: 16px;
  }
`

export default ArticleTags
